import { instance } from '@app/api/axios';
import { useShowToaster } from '@shared/ui/messages/useToaster';
import { useRequestError } from '@app/api/useRequestError';

export function useEmail() {
  const showToaster = useShowToaster();
  const handleRequestError = useRequestError();

  // Отправка пароля для верификации старого email
  const sendOldEmail = async (data) => {
    try {
      const res = await instance.post('/email/send-old-email', data);
      showToaster('success', res?.data?.message);
      return true;
    } catch (err) {
      return handleRequestError(err);
    }
  };

  // Верификация старого email
  const verifyOldEmail = async (data) => {
    try {
      await instance.post('/email/verify-old-email', data);
      return true;
    } catch (err) {
      return handleRequestError(err);
    }
  };

  // Отправка кода на новый email
  const sendNewEmail = async (data) => {
    try {
      const res = await instance.post('/email/send-new-email', data);
      showToaster('success', res?.data?.message);
      return true;
    } catch (err) {
      return handleRequestError(err);
    }
  };

  // Верификация нового email c помощью пинкода
  const verifyNewEmail = async (data) => {
    try {
      const res = await instance.post('/email/verify-new-email', data);
      showToaster('success', res?.data?.message);
      return true;
    } catch (err) {
      return handleRequestError(err);
    }
  };

  return { sendOldEmail, verifyOldEmail, sendNewEmail, verifyNewEmail };
}
